import React, {useState} from "react";
import {useTranslation} from "react-i18next";

import {SUPPORTED_LANGUAGES} from "../i18n";

import MDBox from "materialDashboard/components/MDBox";
import {navbarIconButton} from "../materialDashboard/examples/Navbars/DashboardNavbar/styles";

import Menu from "@mui/material/Menu";
import IconButton from "@mui/material/IconButton";
import Icon from "@mui/material/Icon";
import NotificationItem from "../materialDashboard/examples/Items/NotificationItem";


const LanguageSelector = (iconsStyle) => {

    const [languageAnchorEl, setLanguageAnchorEl] = useState(false);

    const handleOpenLanguageMenu = (event) => {
        setLanguageAnchorEl(event.currentTarget);
    }

    const handleCloseLanguageMenu = () => {
        setLanguageAnchorEl(null);
    }

    return <MDBox color="inherit">
        <IconButton
            size="small"
            disableRipple
            color="inherit"
            sx={navbarIconButton}
            aria-controls="notification-menu"
            aria-haspopup="true"
            variant="contained"
            onClick={handleOpenLanguageMenu}
        >
            <Icon sx={iconsStyle}>language</Icon>
        </IconButton>
        <LanguageMenu anchorEl={languageAnchorEl}
                  open={Boolean(languageAnchorEl)}
                  onClose={handleCloseLanguageMenu}/>
    </MDBox>
}

const LanguageMenu = ({anchorEl, open, onClose}) => {

    const {i18n} = useTranslation();

    const selectedLanguage = SUPPORTED_LANGUAGES.hasOwnProperty(i18n.language) ? SUPPORTED_LANGUAGES[i18n.language] : "Unknown";

    const handleChangeLanguage = (lng) => async () => {
        localStorage.setItem('i18nextLng', lng);  // save the selected language to local storage
        await i18n.changeLanguage(lng);
        onClose();
    };

    return <Menu
        anchorEl={anchorEl}
        anchorReference={null}
        anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
        }}
        open={Boolean(open)}
        onClose={onClose}
        sx={{ mt: 2 }}
    >
        {
            Object.entries(SUPPORTED_LANGUAGES).map(([key, value]) => (
                selectedLanguage === value ?
                    <NotificationItem key={key} icon={<Icon>check</Icon>} title={value} onClick={handleChangeLanguage(key)}/>
                    :
                    <NotificationItem key={key} icon={<Icon/>} title={value} onClick={handleChangeLanguage(key)}/>
            ))
        }
    </Menu>
}

export default LanguageSelector;